import React, { useState, useEffect } from 'react';
import { dashboardService } from '../services/api';

function Dashboard() {
  const [stats, setStats] = useState(null);
  const [recentScreens, setRecentScreens] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDashboard();
    const interval = setInterval(loadDashboard, 10000);
    return () => clearInterval(interval);
  }, []);

  const loadDashboard = async () => {
    try {
      const response = await dashboardService.getStats();
      setStats(response.data);
      setRecentScreens(response.data.recent_screens || []);
    } catch (error) {
      console.error('Erreur chargement dashboard:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Chargement...</div>;
  }

  if (!stats) {
    return <div className="loading">Erreur de chargement</div>;
  }

  return (
    <div className="app-main">
      <div className="page-header">
        <h1>Dashboard</h1>
        <p className="page-subtitle">Vue d'ensemble de votre système de digital signage</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-label">Écrans totaux</div>
          <div className="stat-value">{stats.total_screens}</div>
        </div>

        <div className="stat-card success">
          <div className="stat-label">En ligne</div>
          <div className="stat-value">{stats.online_screens}</div>
        </div>

        <div className="stat-card danger">
          <div className="stat-label">Hors ligne</div>
          <div className="stat-value">{stats.offline_screens}</div>
        </div>

        <div className="stat-card">
          <div className="stat-label">Groupes</div>
          <div className="stat-value">{stats.total_groups}</div>
        </div>

        <div className="stat-card success">
          <div className="stat-label">TV allumées</div>
          <div className="stat-value">{stats.tv_on}</div>
        </div>

        <div className="stat-card">
          <div className="stat-label">TV éteintes</div>
          <div className="stat-value">{stats.tv_off}</div>
        </div>
      </div>

      <div className="section">
        <div className="section-header">
          <h2 className="section-title">Écrans récents</h2>
        </div>

        {recentScreens.length === 0 ? (
          <div className="empty-state">
            <p>Aucun écran connecté pour le moment</p>
            <p className="help-text">Les Raspberry Pi s'enregistrent automatiquement au premier heartbeat</p>
          </div>
        ) : (
          <div className="cards-grid">
            {recentScreens.map(screen => (
              <div key={screen.id} className="card">
                <div className="card-header">
                  <div className="card-title">{screen.name}</div>
                  <span className={`badge ${screen.status === 'online' ? 'online' : 'offline'}`}>
                    {screen.status === 'online' ? 'En ligne' : 'Hors ligne'}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Dashboard;
